module.exports = __webpack_public_path__ + "static/chemnsfreu.5fd46715.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/portfolio/chemnsfreu.webp
// module id = 441
// module chunks = 23899280101116